import { action, observable } from 'mobx';
import { FormulaFormVM } from '../template/FormulaFormVM';
import { HydraulicFormulaController } from "cd-eft/services/eftSetApi";
import MessageCenter from "cd-eft/components/common/MessageCenter/MessageCenterVM";


interface IhoodInletForm {
  commonPipeDto: {
    extraPipeBeyondToe: string,
    manningsN: string,
    pipeDiameter: string,
    skewAngle: string
  },
  commonSideSlopeDto: {
    downStream: string,
    upStream: string
  },
  earthWorksDto: {
    dsToeElev: string,
    topWidth: string
  },
  hoodedInletElevationDto: {
    auxSpillwayElev: string,
    enableTailWater: boolean,
    inletElev: string,
    outletElev: string,
    tailwaterElev: string,
    toeElev: string,
    topElev: string,
    waterElev: string
  }
}

interface IhoodInletFormResults {
  pipeLength?: string;
  errorResponse?: {
    errorCode?: string;
    errorMessage?: string;
    errorType?: string;
  };
  seepagePath?: string;
  capacity?: string;
  validationPass?: boolean;
}

export class HoodedInletVM extends FormulaFormVM {
  readonly formLabelsForExport;
  readonly resultLabelsForExport;
  constructor(props) {
    super(props); //optional
    this.formLabelsForExport = {
      topWidth: 'Top Width (ft)',
      upStream: 'Side Slopes Up-stream (ft/ft)',
      downStream: 'Side Slopes Down-stream (ft/ft)',
      manningsN: "Manning's n",
      pipeDiameter: 'Pipe Diameter (in)',
      extraPipeBeyondToe: 'Extra Pipe Boyond Toe (ft)',
      skewAngle: 'Skew Angle°',
      topElev: 'Top Elevation (ft)',
      auxSpillwayElev: 'Auxiliary Spillway Elevation (ft)',
      waterElev: 'Water Elevation (ft)',
      toeElev: 'Toe Elevation (ft)',
      inletElev: 'Inlet Elevation (ft)',
      outletElev: 'Outlet Elevation (ft)',
      enableTailWater: 'Enable Tailwater', 
      tailwaterElev: 'Tailwater Elevation (ft)',
    };
    this.resultLabelsForExport = {
      capacity: 'Capacity (cfs)',
      pipeLength: 'Length of Pipe (ft)',
      seepagePath: 'Seepage Path (ft)',
    };
    this.helpLink = "https://usdagcc.sharepoint.com/:b:/r/sites/FPAC-NRCS-EngineeringPlanningAnalysisandDesignSoftwareEPAD/Shared%20Documents/General/NETS-Support%20Documents/Formulas%20Documentation/Help%20Select%20n%20Value.pdf?csf=1&web=1&e=L9CuXP"
  }

  @observable hoodInletFormData: IhoodInletForm = {
    commonPipeDto: {
      extraPipeBeyondToe: "0",
      manningsN: "0",
      pipeDiameter: "0",
      skewAngle: "0",
    },
    commonSideSlopeDto: {
      downStream: "0",
      upStream: "0",
    },
    earthWorksDto: {
      dsToeElev: "0",
      topWidth: "0",
    },
    hoodedInletElevationDto: {
      auxSpillwayElev: "0",
      enableTailWater: true,
      inletElev: "0",
      outletElev: "0",
      tailwaterElev: "0",
      toeElev: "0",
      topElev: "0",
      waterElev: "0",
    },
  };

  @observable hoodInletFormResults: IhoodInletFormResults = {
    pipeLength: "0.00",
    seepagePath: "0.00",
    capacity: "0.00",
  };
  @observable hoodedInletFormInputSnapshot: IhoodInletForm | undefined = undefined;
  @observable hasResults: boolean = false;

  @observable formValidation = {
    hasError: true,
    topWidth: false,
    upStream: false,
    downStream: false,
    manningsN: false,
    pipeDiameter: false,
    extraPipeBeyondToe: false,
    skewAngle: false,
    topElev: false,
    auxSpillwayElev: false,
    waterElev: false,
    toeElev: false,
    inletElev: false,
    outletElev: false,
    tailwaterElev: false,
    enableTailWater: false,
    formErrors: {
      topWidth: '',
      upStream: '',
      downStream: '',
      manningsN: '',
      pipeDiameter: '',
      extraPipeBeyondToe: '',
      skewAngle: '',
      topElev: '',
      auxSpillwayElev: '',
      waterElev: '',
      toeElev: '',
      inletElev: '',
      outletElev: '',
      tailwaterElev: '',
      enableTailWater: '',
    },
  };

  @action.bound hoodInletErrorClass(field) {
    const errorMessage = this.formValidation.formErrors[field];
    return errorMessage?.length === 0 ? '' : ' usa-input--error';
  }
  @action.bound setFixedValue(name, fixed) {
    const event1 = {
     target: {
     name: name,
     value: this.roundingHelperString(fixed, name === 'manning-n' ? 4 : 2)
     }
     }
    this.handleInputChange(event1, true);
     }

  @action.bound handleOnKeyDown(event) {
    ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault();
  }

  @action.bound toggleEnableTailwaterElevation() {
    this.hoodInletFormData.hoodedInletElevationDto.enableTailWater = !this.hoodInletFormData
      .hoodedInletElevationDto.enableTailWater;
      this.formValidation.tailwaterElev = false;
      this.formValidation.formErrors.tailwaterElev = '';
      this.formValidation.hasError = false;
      if(!this.hoodInletFormData.hoodedInletElevationDto.enableTailWater){this.hoodInletFormData.hoodedInletElevationDto.tailwaterElev = "0"}
  }

  @action.bound handleInputChange(event, within?: boolean) {
    const { name } = event.target;
    let value = event.target.value;
    if (!within && value.length > 7) {
      return;
    }

    switch (name) {
      case 'top-width':
          this.hoodInletFormData.earthWorksDto.topWidth = value;
        break;
      case 'up-stream':
          this.hoodInletFormData.commonSideSlopeDto.upStream = value;
        break;
      case 'do-stream':
          this.hoodInletFormData.commonSideSlopeDto.downStream = value;
        break;
      case 'manning-n':
          this.hoodInletFormData.commonPipeDto.manningsN = value;
        break;
      case 'pipe-diameter':
          this.hoodInletFormData.commonPipeDto.pipeDiameter = value;
        break;
      case 'extra-pipe-b-toe':
          this.hoodInletFormData.commonPipeDto.extraPipeBeyondToe = value;
        break;
      case 'skew-angle':
          this.hoodInletFormData.commonPipeDto.skewAngle = value;
        break;
      case 'top-elevation':
          this.hoodInletFormData.hoodedInletElevationDto.topElev = value;
        break;
      case 'aux-spillway-Elevation':
          this.hoodInletFormData.hoodedInletElevationDto.auxSpillwayElev = value;
        break;
      case 'water-elevation':
          this.hoodInletFormData.hoodedInletElevationDto.waterElev = value;
        break;
      case 'toe-elevation':
          this.hoodInletFormData.hoodedInletElevationDto.toeElev = value;
        break;
      case 'inlet-elevation':
          this.hoodInletFormData.hoodedInletElevationDto.inletElev = value;
        break;
      case 'outlet-elevation':
          this.hoodInletFormData.hoodedInletElevationDto.outletElev = value;
        break;
      case 'tailwater-elevation':
          this.hoodInletFormData.hoodedInletElevationDto.tailwaterElev = value;
        break;
    }
  }

  @action.bound async validateInput(name, value) {
      let valuSet = 0;
      if (name === 'manning-n') {
        valuSet = this.roundingHelperNumber(parseFloat(value), 4);
      } else {
        valuSet = this.roundingHelperNumber(parseFloat(value), 2);
      }
      this.setFixedValue(name, valuSet);

    switch (name) {
      case 'top-width':
        if (value < 0 ) {
          this.formValidation.topWidth = true;
          this.formValidation.formErrors.topWidth = ' ';
          this.formValidation.topWidth = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined,this.formLabelsForExport.topWidth.replace(/(\s\([\w\W]*\))/, '')); 
        } else {
          this.formValidation.topWidth = false;
          this.formValidation.formErrors.topWidth = '';
          this.formValidation.topWidth = false;
        }
        break;
    case 'up-stream':
      if (value < 0 ) {
        this.formValidation.upStream = true;
        this.formValidation.formErrors.upStream = ' ';
        this.formValidation.upStream = true;
        await MessageCenter.addNotificationFromCode('Common_10', undefined,this.formLabelsForExport.upStream.replace(/(\s\([\w\W]*\))/, '')); 
      } else {
        this.formValidation.upStream = false;
        this.formValidation.formErrors.upStream = '';
        this.formValidation.upStream = false;
      }
      break;
    case 'do-stream':
      if (value < 0 ) {
        this.formValidation.downStream = true;
        this.formValidation.formErrors.downStream = ' ';
        this.formValidation.downStream = true;
        await MessageCenter.addNotificationFromCode('Common_10', undefined,this.formLabelsForExport.downStream.replace(/(\s\([\w\W]*\))/, '')); 
      } else {
        this.formValidation.downStream = false;
        this.formValidation.formErrors.downStream = '';
        this.formValidation.downStream = false;
      }
      break;
      case 'manning-n':
        if (value === '' || Number.isNaN(valuSet) || valuSet < 0.0001 || valuSet > 1) { // value were received as NaN which didnot trigger error on input box so addded isNaN check
          this.formValidation.manningsN = true;
          this.formValidation.formErrors.manningsN = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Formula_02'); 
        } else {
          this.formValidation.manningsN = false;
          this.formValidation.formErrors.manningsN = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'pipe-diameter':
        if (value === '' || Number.isNaN(valuSet) || valuSet < 0.02 ) {
          this.formValidation.pipeDiameter = true;
          this.formValidation.formErrors.pipeDiameter = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Formula_07'); 
        } else {
          this.formValidation.pipeDiameter = false;
          this.formValidation.formErrors.pipeDiameter = '';
          this.formValidation.hasError = false;
        }
        break;
        case 'extra-pipe-b-toe':
          if (value < 0 ) {
            this.formValidation.extraPipeBeyondToe = true;
            this.formValidation.formErrors.extraPipeBeyondToe = ' ';
            this.formValidation.extraPipeBeyondToe = true;
            await MessageCenter.addNotificationFromCode('Common_10', undefined,this.formLabelsForExport.extraPipeBeyondToe.replace(/(\s\([\w\W]*\))/, '')); 
          } else {
            this.formValidation.extraPipeBeyondToe = false;
            this.formValidation.formErrors.extraPipeBeyondToe = '';
            this.formValidation.extraPipeBeyondToe = false;
          }
          break;
      case 'skew-angle':
        if (value === '' || valuSet === 0 || Number.isNaN(valuSet)) {
          this.formValidation.skewAngle = true;
          this.formValidation.formErrors.skewAngle = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined,this.formLabelsForExport.skewAngle.replace(/(\s\([\w\W]*\))|°/, '')); 
        } else {
          this.formValidation.skewAngle = false;
          this.formValidation.formErrors.skewAngle = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'top-elevation':
        if (value === '' || Number.isNaN(valuSet) || valuSet <= 0) {
          this.formValidation.topElev = true;
          this.formValidation.formErrors.topElev = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined,this.formLabelsForExport.topElev.replace(/(\s\([\w\W]*\))/, '')); 
        } else {
          this.formValidation.topElev = false;
          this.formValidation.formErrors.topElev = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'aux-spillway-Elevation':
        if (value === '' || Number.isNaN(valuSet)|| valuSet <= 0) {
          this.formValidation.auxSpillwayElev = true;
          this.formValidation.formErrors.auxSpillwayElev = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined,this.formLabelsForExport.auxSpillwayElev.replace(/(\s\([\w\W]*\))/, '')); 
        } else {
          this.formValidation.auxSpillwayElev = false;
          this.formValidation.formErrors.auxSpillwayElev = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'water-elevation':
        if (value === ''|| Number.isNaN(valuSet) || valuSet <= 0) {
          this.formValidation.waterElev = true;
          this.formValidation.formErrors.waterElev = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined,this.formLabelsForExport.waterElev.replace(/(\s\([\w\W]*\))/, '')); 
        } else {
          this.formValidation.waterElev = false;
          this.formValidation.formErrors.waterElev = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'toe-elevation':
        if (value === '' || Number.isNaN(valuSet) || valuSet <= 0) {
          this.formValidation.toeElev = true;
          this.formValidation.formErrors.toeElev = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined,this.formLabelsForExport.toeElev.replace(/(\s\([\w\W]*\))/, '')); 
        } else {
          this.formValidation.toeElev = false;
          this.formValidation.formErrors.toeElev = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'inlet-elevation':
        if (value === '' || Number.isNaN(valuSet) || valuSet <= 0) {
          this.formValidation.inletElev = true;
          this.formValidation.formErrors.inletElev = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10',undefined,this.formLabelsForExport.inletElev.replace(/(\s\([\w\W]*\))/, ''));
        } else {
          this.formValidation.inletElev = false;
          this.formValidation.formErrors.inletElev = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'outlet-elevation':
        if (value === '' || Number.isNaN(valuSet) || valuSet <= 0) {
          this.formValidation.outletElev = true;
          this.formValidation.formErrors.outletElev = ' ';
          this.formValidation.hasError = true;
          await MessageCenter.addNotificationFromCode('Common_10', undefined,this.formLabelsForExport.outletElev.replace(/(\s\([\w\W]*\))/, ''));
        } else {
          this.formValidation.outletElev = false;
          this.formValidation.formErrors.outletElev = '';
          this.formValidation.hasError = false;
        }
        break;
      case 'tailwater-elevation':
        if(this.hoodInletFormData.hoodedInletElevationDto.enableTailWater){
          if (value < 0) {
            this.formValidation.tailwaterElev = true;
            this.formValidation.formErrors.tailwaterElev = ' ';
            this.formValidation.hasError = true;
            await MessageCenter.addNotificationFromCode('Common_10', undefined,this.formLabelsForExport.tailwaterElev.replace(/(\s\([\w\W]*\))/, ''));
          } else {
            this.formValidation.tailwaterElev = false;
            this.formValidation.formErrors.tailwaterElev = '';
            this.formValidation.hasError = false;
          }
        }
        break;
    }
  }

  get validateRequiredInputs() {
    if (this.formValidation.topElev || this.formValidation.manningsN || this.formValidation.pipeDiameter || this.formValidation.skewAngle
      || this.formValidation.auxSpillwayElev || this.formValidation.waterElev ||  this.formValidation.toeElev ||  this.formValidation.inletElev 
      ||  this.formValidation.outletElev
    ) {
      return false;
    }
    return true;
  }
  @action async validateReqInput() {
    await this.validateInput("manning-n", this.hoodInletFormData.commonPipeDto.manningsN);
    await this.validateInput("pipe-diameter", this.hoodInletFormData.commonPipeDto.pipeDiameter);
    await this.validateInput("skew-angle", this.hoodInletFormData.commonPipeDto.skewAngle);
    await this.validateInput("top-elevation", this.hoodInletFormData.hoodedInletElevationDto.topElev);
    await this.validateInput("aux-spillway-Elevation", this.hoodInletFormData.hoodedInletElevationDto.auxSpillwayElev);
    await this.validateInput("water-elevation", this.hoodInletFormData.hoodedInletElevationDto.waterElev);
    await this.validateInput("toe-elevation", this.hoodInletFormData.hoodedInletElevationDto.toeElev);
    await this.validateInput("inlet-elevation", this.hoodInletFormData.hoodedInletElevationDto.inletElev);
    await this.validateInput("outlet-elevation", this.hoodInletFormData.hoodedInletElevationDto.outletElev);
  }
  @action.bound async computeHoodInlet() {
    this.disableComputeBtn = true;
    this.disablePrintBtn = true;
    this.isLoading = true;
    MessageCenter.blockCalls(['Common_26']);
    await this.validateReqInput();
    if (this.validateRequiredInputs) {
      try {
        const hoodInletPayload =  {
          commonPipeDto: {
            extraPipeBeyondToe: parseFloat(this.hoodInletFormData.commonPipeDto.extraPipeBeyondToe),
            manningsN: parseFloat(this.hoodInletFormData.commonPipeDto.manningsN),
            pipeDiameter: parseFloat(this.hoodInletFormData.commonPipeDto.pipeDiameter),
            skewAngle: parseFloat(this.hoodInletFormData.commonPipeDto.skewAngle),
          },
          commonSideSlopeDto: {
            downStream: parseFloat(this.hoodInletFormData.commonSideSlopeDto.downStream),
            upStream: parseFloat(this.hoodInletFormData.commonSideSlopeDto.upStream),
          },
          earthWorksDto: {
            dsToeElev: parseFloat(this.hoodInletFormData.earthWorksDto.dsToeElev),
            topWidth: parseFloat(this.hoodInletFormData.earthWorksDto.topWidth),
          },
          hoodedInletElevationDto: {
            auxSpillwayElev:parseFloat(this.hoodInletFormData.hoodedInletElevationDto.auxSpillwayElev),
            enableTailWater:this.hoodInletFormData.hoodedInletElevationDto.enableTailWater,
            inletElev: parseFloat(this.hoodInletFormData.hoodedInletElevationDto.inletElev),
            outletElev: parseFloat(this.hoodInletFormData.hoodedInletElevationDto.outletElev),
            tailwaterElev: parseFloat(this.hoodInletFormData.hoodedInletElevationDto.tailwaterElev),
            toeElev: parseFloat(this.hoodInletFormData.hoodedInletElevationDto.toeElev),
            topElev:parseFloat(this.hoodInletFormData.hoodedInletElevationDto.topElev),
            waterElev: parseFloat(this.hoodInletFormData.hoodedInletElevationDto.waterElev),
          },
        }
        const response = await HydraulicFormulaController.calculateHoodedInletResultsUsingPOST(
          hoodInletPayload
        );
        const shortCode = response?.data?.errorResponse?.errorCode?.replace(/[123]_[a-zA-Z]+_[a-zA-Z]+_/, '');
        if (response && response.data) {
          if (response.data.validationPass) {
            this.hasResults = true;
            this.disablePrintBtn = false;
            this.hoodInletFormResults.pipeLength = response.data.lengthOfPipe? this.roundingHelperString(response.data.lengthOfPipe, 2) : "0.00";
            this.hoodInletFormResults.seepagePath = response.data.seepagePath? this.roundingHelperString(response.data.seepagePath, 2) : "0.00";
            this.hoodInletFormResults.capacity =response.data.capacity? this.roundingHelperString(response.data.capacity, 2) : "0.00";
            this.setPlotData(response.data.stageDischargeList!);
            this.hoodedInletFormInputSnapshot = { 
              commonPipeDto: { ...this.hoodInletFormData.commonPipeDto },
              commonSideSlopeDto: { ...this.hoodInletFormData.commonSideSlopeDto },
              earthWorksDto: { ...this.hoodInletFormData.earthWorksDto },
              hoodedInletElevationDto: { ...this.hoodInletFormData.hoodedInletElevationDto }
            }
          } else if (
            response?.data?.errorResponse?.errorMessage !== undefined &&
            response?.data?.errorResponse?.errorType !== undefined
          ) {
            MessageCenter.resetMessageCenter();
            MessageCenter.addNotification(
              response?.data?.errorResponse?.errorMessage,
              response?.data?.errorResponse?.errorType,
              shortCode
            );
            this.hasResults = false;
            this.resetPlotData();
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
    else {
      // If we are missing required inputs or they are invalid
      // If field validation has been added, input specific messages should not be shown at this time.
      MessageCenter.resetMessageCenter();
      await MessageCenter.addNotificationFromCode('Common_26');
      this.hasResults = false;
      this.resetPlotData();
    }
    this.disableComputeBtn = false;
    this.isLoading = false;
    MessageCenter.unblockCalls();
  }

  @action.bound printHoodInlet() { }

  @action.bound launchAndExport() {
    // disable print button
    this.disablePrintBtn = true;
    this.exportedInputs = [];
    this.exportedResults = [];

    for (const childProperty in this.formLabelsForExport) {
      if (this.formLabelsForExport.hasOwnProperty(childProperty)) {
        const label = this.formLabelsForExport[childProperty];
        
        for (const input in this.hoodedInletFormInputSnapshot) {
          if (this.hoodedInletFormInputSnapshot.hasOwnProperty(input)) {
            const childObj = this.hoodedInletFormInputSnapshot[input];
            
            if (childObj.hasOwnProperty(childProperty)) {
              const value = childObj[childProperty];
              if (label && value !== '') {
                if ((label === 'Enable Tailwater')) {
                  this.exportedInputs.push({
                    label: label,
                    value: this.hoodedInletFormInputSnapshot.hoodedInletElevationDto.enableTailWater ? 'Checked' : "Unchecked", 
                  });
                } else {
                  this.exportedInputs.push({
                    label: label,
                    value: value, 
                  });
                }
              }
            }
          }
        }
      }
    }
    for (const result in this.resultLabelsForExport) {
      if (this.resultLabelsForExport.hasOwnProperty(result)) {
        const label = this.resultLabelsForExport[result];
        const value = this.hoodInletFormResults[result];
        if (label && value !== undefined) {
          this.exportedResults.push({
            label: label,
            value: value && !isNaN(value) ? this.roundingHelperString(parseFloat(value), 2) : value,
          });
        }
      }
    }
    this.printFormula();
    this.disablePrintBtn = false;
  }

  @action.bound initializeDefaultValues(): void {
    const { hoodedInletElevationDto, commonPipeDto, commonSideSlopeDto, earthWorksDto } = this.defaultValues;
    this.hoodInletFormData.commonPipeDto = {
      extraPipeBeyondToe: this.roundingHelperString(commonPipeDto.extraPipeBeyondToe, 2),
      pipeDiameter: this.roundingHelperString(commonPipeDto.pipeDiameter, 2),
      skewAngle: this.roundingHelperString(commonPipeDto.skewAngle, 2),
      manningsN: this.roundingHelperString(commonPipeDto.manningsN, 4),
    };

    this.hoodInletFormData.commonSideSlopeDto = {
      upStream: this.roundingHelperString(commonSideSlopeDto.upStream, 2),
      downStream: this.roundingHelperString(commonSideSlopeDto.downStream, 2),
    };

    this.hoodInletFormData.earthWorksDto = {
      topWidth: this.roundingHelperString(earthWorksDto.topWidth, 2),
      dsToeElev: this.roundingHelperString(hoodedInletElevationDto.toeElev, 2),
    };

    this.hoodInletFormData.hoodedInletElevationDto = {
      topElev: this.roundingHelperString(hoodedInletElevationDto.topElev, 2),
      auxSpillwayElev: this.roundingHelperString(hoodedInletElevationDto.auxSpillwayElev, 2),
      waterElev: this.roundingHelperString(hoodedInletElevationDto.waterElev, 2),
      inletElev: this.roundingHelperString(hoodedInletElevationDto.inletElev, 2),
      outletElev: this.roundingHelperString(hoodedInletElevationDto.outletElev, 2),
      tailwaterElev: this.roundingHelperString(hoodedInletElevationDto.tailwaterElev, 2),
      enableTailWater: !hoodedInletElevationDto.enableTailWater,
      toeElev: this.roundingHelperString(hoodedInletElevationDto.toeElev, 2),
    };
    this.hoodedInletFormInputSnapshot = { commonPipeDto: { ...this.hoodInletFormData.commonPipeDto }, commonSideSlopeDto: { ...this.hoodInletFormData.commonSideSlopeDto }, earthWorksDto: { ...this.hoodInletFormData.earthWorksDto }, hoodedInletElevationDto: { ...this.hoodInletFormData.hoodedInletElevationDto } }
  }
}

